module.exports = __webpack_public_path__ + "0682a6c1.jpg";